module.exports = __webpack_public_path__ + "static/img/logo.f489a48d.jpeg";